var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.99988C0.75 3.30952 1.30964 2.74988 2 2.74988H18C18.6904 2.74988 19.25 3.30952 19.25 3.99988V17.9999C19.25 18.6902 18.6904 19.2499 18 19.2499H2C1.30964 19.2499 0.75 18.6902 0.75 17.9999V3.99988Z",
    fill: "white",
    stroke: "#727272",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 4.99988V-0.00012207H5.75V4.99988H4.25ZM19.5 8.24988H0.5V6.74988H19.5V8.24988ZM14.25 -0.00012207V4.99988H15.75V-0.00012207H14.25Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10.9999H4V12.4999H16V10.9999ZM11 13.9999H4V15.4999H11V13.9999Z",
    fill: "#727272"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon__calendar.7098f0e53753b9d3ae5ae8d1d661303b.svg";
export { ForwardRef as ReactComponent };